import { jsx as e, jsxs as i, Fragment as O } from "react/jsx-runtime";
import { useState as y, useRef as U } from "react";
import { useApp as z } from "../../../context/app/index.js";
import { files as Q } from "../../../queries/files/index.js";
import { T as S, D as l, b as s, e as V } from "../../../pointsGraph-DTJju-rA.js";
import { Avatar as q, alpha as G, Chip as H, Menu as J, MenuItem as T, ListItemIcon as L, ListItemText as I } from "@mui/material";
import { FileLocationEnum as v } from "../../../helpers/daymaptypes.js";
import { B as K } from "../../../index-BZpqZYNM.js";
const ne = ({
  name: D,
  description: F,
  extension: g,
  modified: b,
  fileId: r,
  download: x,
  contentType: k,
  pdf: R,
  onAnnotationsClicked: n,
  location: c,
  path: m,
  selected: A
}) => {
  const { refetch: C } = new Q.FileDownLoadLink({ FileId: r ?? 0, ContentProvider: k ?? 0, Pdf: R ?? !1 }).ToQuery(), { nativeDownload: f } = z(), [E, o] = y(!1), p = U(null), [M, d] = y(!1), P = () => {
    n ? d(!0) : u();
  }, u = async () => {
    if (!x)
      return;
    if (o(!0), c === v.URL && m)
      return await K.open({ url: m }), o(!1), !1;
    const { data: a } = await C();
    if (!a) {
      o(!1);
      return;
    }
    if (f)
      await f(a);
    else {
      const t = document.createElement("a");
      t.href = a, t.click(), t && t.remove();
    }
    o(!1);
  }, { icon: j, color: h } = S(c === v.URL ? "url" : g);
  let B = /* @__PURE__ */ e(q, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: G(h, 0.15), color: h }, children: j }), w = [];
  return n && w.push(/* @__PURE__ */ e(H, { size: "small", label: "Teacher feedback", icon: /* @__PURE__ */ e(l, { iconType: s.Annotations }) }, "annotations")), /* @__PURE__ */ i(O, { children: [
    /* @__PURE__ */ e(V, { itemType: "file", ref: p, onClick: P, title: D, description: F, avatar: B, date: b, loading: E, chips: w, selected: A }),
    /* @__PURE__ */ i(
      J,
      {
        id: "basic-menu",
        anchorEl: p.current,
        open: M,
        onClose: () => d(!1),
        children: [
          /* @__PURE__ */ i(T, { onClick: u, children: [
            /* @__PURE__ */ e(L, { children: /* @__PURE__ */ e(l, { iconType: s.Download }) }),
            /* @__PURE__ */ e(I, { children: "Download file" })
          ] }),
          /* @__PURE__ */ i(T, { onClick: () => n && r && n(r), children: [
            /* @__PURE__ */ e(L, { children: /* @__PURE__ */ e(l, { iconType: s.Annotations }) }),
            /* @__PURE__ */ e(I, { children: "View Annotations" })
          ] })
        ]
      }
    )
  ] });
};
export {
  ne as FileItem
};
//# sourceMappingURL=file.js.map
